module.exports = __webpack_public_path__ + "static/media/290246.47d42d46.png";